import { render, staticRenderFns } from "./ActivatorApp.vue?vue&type=template&id=4a36a74e&scoped=true&"
import script from "./ActivatorApp.vue?vue&type=script&lang=ts&"
export * from "./ActivatorApp.vue?vue&type=script&lang=ts&"
import style0 from "./ActivatorApp.vue?vue&type=style&index=0&id=4a36a74e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a36a74e",
  null
  
)

export default component.exports